module.exports = __webpack_public_path__ + "static/media/bw-logo-white-desktop.9016f0ba.svg";